/* eslint-disable camelcase */
import * as React from 'react';
import { GlyphName } from '@remind/r101-glyphs';

import { ReachabilityStatus } from 'globalTypes';
import Coin from 'components/Coin';
import LayerTrigger from 'components/LayerTrigger';
import Tooltip from 'components/Tooltip';
import Glyph from 'components/Glyph';
import { CoinColor } from 'components/Coin';

type ReachabilityStyles = {
  rich: {
    backgroundColor: CoinColor;
    iconName: GlyphName;
  };
  poor: {
    backgroundColor: CoinColor;
    iconName: GlyphName;
  };
  unreachable: {
    backgroundColor: CoinColor;
    iconName: GlyphName;
  };
};

export const reachabilityStyles: ReachabilityStyles = {
  rich: {
    backgroundColor: 'mascot',
    iconName: 'lightning-bolt',
  },
  poor: {
    backgroundColor: 'percussion',
    iconName: 'ellipses',
  },
  unreachable: {
    backgroundColor: 'percussion',
    iconName: 'close',
  },
};

type ReachabilityAction = {
  type: 'link' | 'add_number';
  text: string;
  link?: string;
};

export type ReachabilityInfo = {
  action?: ReachabilityAction;
  reason_short?: string;
  reasonShort?: string;
  reason_long?: string;
  reasonLong?: string;
  status: ReachabilityStatus;
};

type Props = {
  displayTooltip?: boolean;
  reachability: ReachabilityInfo;
  style?: React.CSSProperties;
};

function ReachabilityBadge({ displayTooltip = true, reachability, style }: Props) {
  if (!reachability) {
    return null;
  }

  const { status, reasonShort, reason_short } = reachability;
  const styles = reachabilityStyles[status];

  return (
    <Coin color={styles.backgroundColor} size="xsmall">
      {displayTooltip ? (
        <LayerTrigger layer={<Tooltip>{reasonShort || reason_short}</Tooltip>} placement="top">
          <Glyph name={styles.iconName} color="whiteout" style={style} solo />
        </LayerTrigger>
      ) : (
        <Glyph name={styles.iconName} color="whiteout" style={style} solo />
      )}
    </Coin>
  );
}

export default ReachabilityBadge;
